<app-boton-whatsapp></app-boton-whatsapp>
<div id="page-top" class="landing-page no-skin-config">
  <div class="navbar-wrapper">
    <nav class="navbar navbar-default navbar-fixed-top navbar-expand-md" role="navigation">
      <div class="container">
        <a class="navbar-brand" href="#">AGÉNDATE APP</a>
        <div class="navbar-header page-scroll">
          <button aria-label="Menu" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar">
            <i class="fa fa-bars"></i>
          </button>
        </div>
        <div class="collapse navbar-collapse justify-content-end" id="navbar">
          <ul class="nav navbar-nav navbar-right">
            <li><a class="nav-link page-scroll" href="#page-top">Inicio</a></li>
            <li><a class="nav-link page-scroll" href="#features">caracteristicas</a></li>
            <li><a class="nav-link page-scroll" href="#team">Equipo</a></li>
            <li><a class="nav-link page-scroll d-none" href="#testimonials">Testimonials</a></li>
            <li><a class="nav-link page-scroll" href="#pricing">Precios</a></li>
            <li><a class="nav-link page-scroll" href="#contact">Contacto</a></li>
            <li><a class="nav-link page-scroll" [routerLink]="['/cuenta/ingresar']">Iniciar sesión</a></li>
            <li><a class="nav-link page-scroll" [routerLink]="['/cuenta/registrarme']">Regístrate</a></li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  <div id="inSlider" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators pb-3">
      <li data-target="#inSlider" data-slide-to="0"></li>
      <li data-target="#inSlider" data-slide-to="1"></li>
      <li data-target="#inSlider" data-slide-to="2"></li>
      <li data-target="#inSlider" data-slide-to="3" class="active"></li>
    </ol>
    <div class="carousel-inner" role="listbox">
      <div class="carousel-item">
        <div class="container">
          <div class="carousel-caption caption-responsive caption-left ml-5 ml-lg-3">
            <span>Agéndate App</span>
            <h1>¡Llena tu agenda!<br>Sin perder tiempo<br>en el celular.</h1>
            <p>Automatiza tus citas y recordatorios.<br>Deja de escribir por WhatsApp y<br>enfócate en tus clientes.</p>
            <a class="btn btn-lg btn-white rounded-pill text-uppercase font-weight-bold animate__animated animate__pulse animate__infinite"
              [href]="constants.urlAppGooglePlay" target="_blanck" role="button">¡EMPEZAR AHORA!</a>
          </div>
          <div class="carousel-image ilustracion-uno animate__animated animate__zoomIn">
            <img class="img-fluid" src="assets/img/landing/slides/ilustracion1.jpg" alt="Aumenta la productividad de tu negocio con Agéndate App" />
          </div>
        </div>
        <div class="header-back one"></div>
      </div>

      <div class="carousel-item">
        <div class="container">
          <div class="carousel-image ilustracion-dos animate__animated animate__zoomIn">
            <img class="img-fluid" src="assets/img/landing/slides/ilustracion2.jpg" alt="Digitaliza tu agenda de barbería o salón de belleza" />
          </div>
          <div class="carousel-caption caption-responsive caption-right ml-5 mr-lg-3">
            <span>Agéndate App</span>
            <h1>Dile adiós<br>al desorden del<br>papel y lápiz.</h1>
            <p>Control total de tu negocio<br>desde la palma de tu mano y<br>en tiempo real.</p>
            <a class="btn btn-lg btn-white rounded-pill text-uppercase font-weight-bold animate__animated animate__pulse animate__infinite"
              [href]="constants.urlAppGooglePlay" target="_blanck" role="button">PRUEBA GRATIS</a>
          </div>
        </div>
        <div class="header-back"></div>
      </div>

      <div class="carousel-item">
        <div class="container">
          <div class="carousel-caption caption-responsive caption-center ml-5 ml-lg-0">
            <span>Agéndate App</span>
            <h1>Recordatorios que eliminan los "No-Show"<br>¡Cero inasistencias hoy!</h1>
          </div>
          <div class="carousel-caption caption-responsive caption-right ml-5 mr-lg-3">
            <h1 class="mt-5">&nbsp;</h1>
            <p class="mt-5">Tus clientes reciben alertas masivas<br>por WhatsApp y SMS para que<br>nadie olvide su turno y tu<br>silla nunca esté vacía.</p>
            <a class="btn btn-lg btn-white rounded-pill text-uppercase font-weight-bold animate__animated animate__pulse animate__infinite"
              [href]="constants.urlAppGooglePlay" target="_blanck" role="button">QUIERO MÁS CITAS</a>
          </div>
          <div class="carousel-image ilustracion-tres animate__animated animate__zoomIn">
            <img class="img-fluid" src="./assets/img/landing/slides/ilustracion3.png" alt="Sistema de recordatorios automáticos para citas" />
          </div>
        </div>
        <div class="header-back"></div>
      </div>

      <div class="carousel-item active">
        <div class="container">
          <div class="carousel-caption caption-responsive caption-left ml-5 ml-lg-5">
            <span>Agéndate App</span>
            <h1>Link de reserva<br>profesional para<br>tus redes sociales.</h1>
            <p>Permite que tus clientes se agenden<br>solos desde Instagram o Facebook<br>las 24 horas del día.</p>
            <a class="btn btn-lg btn-white rounded-pill text-uppercase font-weight-bold animate__animated animate__pulse animate__infinite"
              [href]="constants.urlAppGooglePlay" target="_blanck" role="button">DESCARGAR APP</a>
          </div>
          <div class="carousel-image ilustracion-cuatro animate__animated animate__zoomIn">
            <img class="img-fluid" src="assets/img/landing/slides/ilustracion4.jpg" alt="Link de agendamiento online para Instagram y Facebook" />
          </div>
        </div>
        <div class="header-back"></div>
      </div>

    </div>
    <a class="carousel-control-prev" href="#inSlider" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Anterior</span>
    </a>
    <a class="carousel-control-next" href="#inSlider" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Siguiente</span>
    </a>
  </div>

  <div id="fondoFeatures">
    <section id="features" class="container services">
      <div class="row">
        <div class="col-lg-12 text-center">
          <span class="text-info">Beneficios Premium</span>
          <h1 class="titulos mb-5"><span class="navy"> Todo lo que tu negocio necesita:</span> </h1>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 d-flex mb-3 justify-content-center">
          <div class="card card-border-radius border-0 text-center" style="width: 18rem;">
            <div class="card-title-services">
              <h2>Alertas de<br>Citas y Eventos</h2>
            </div>
            <img loading="lazy" src="assets/img/landing/caracteristicas/caracteristica1.svg" class="card-img-top card-img-services"
              alt="Notificaciones masivas por WhatsApp, SMS y Email">
            <div class="card-body">
              <p class="card-text">Llega a tus clientes por donde ellos prefieren: WhatsApp, SMS o Email. ¡Comunicación efectiva al instante!</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 d-flex mb-3 justify-content-center">
          <div class="card card-border-radius border-0 text-center" style="width: 18rem;">
            <div class="card-title-services">
              <h2>Productividad<br>al Máximo</h2>
            </div>
            <img loading="lazy" src="assets/img/landing/caracteristicas/caracteristica2.svg" class="card-img-top card-img-services"
              alt="Optimización de procesos operativos en PyMEs">
            <div class="card-body">
              <p class="card-text">Libera a tus colaboradores de las llamadas y mensajes constantes. Menos ausentismo significa más ingresos.</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 d-flex mb-3 justify-content-center">
          <div class="card card-border-radius border-0 text-center" style="width: 18rem;">
            <div class="card-title-services">
              <h2>Experiencia<br>VIP para Clientes</h2>
            </div>
            <img loading="lazy" src="assets/img/landing/caracteristicas/caracteristica3.svg" class="card-img-top card-img-services"
              alt="Fidelización de clientes mediante tecnología">
            <div class="card-body">
              <p class="card-text">Ofrece un servicio moderno y profesional. Un cliente bien informado es un cliente que siempre vuelve.</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 d-flex mb-3 justify-content-center">
          <div class="card card-border-radius border-0 text-center" style="width: 18rem;">
            <div class="card-title-services">
              <h2>Escalabilidad<br>Garantizada</h2>
            </div>
            <img loading="lazy" src="assets/img/landing/caracteristicas/caracteristica4.svg" class="card-img-top card-img-services"
              alt="Planes flexibles para crecimiento empresarial">
            <div class="card-body">
              <p class="card-text">
                Desde barberos independientes hasta grandes franquicias. Tenemos el plan perfecto para ti.
              </p>
              <a class="btn btn-lg btn-info rounded-pill text-uppercase font-weight-bold my-4 animate__animated animate__pulse animate__infinite {{ constants.gtm.css.contact }}"
                href="https://wa.me/573019246082?text=Hola%2C%20estoy%20interesado%20en%20conocer%20m%C3%A1s%20sobre%20los%20planes%20de%20%20Ag%C3%A9ndate%20App"
                target="_black" role="button">SOLICITAR COTIZACIÓN</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="bgCirculo"></div>

  <div class="contFondoTextura mt-5 justify-content-center">
    <section class="container">
      <div class="row">
        <div class="col-12 col-lg-6 text-white">
          <span class="text-info">Omnicanalidad</span>
          <h1 class="titulos text-white">
            Conecta con tus clientes<br>donde ellos están,<br>sin esfuerzo manual.<br>
            <span class="parrafos"> Notificaciones masivas e inteligentes.</span>
          </h1>
          <p class="text-white">
            Agéndate App automatiza la confirmación de tus citas por múltiples canales, garantizando que tu agenda siempre esté llena.
          </p>
          <div class="row">
            <div class="col-12 col-lg-6 my-lg-4">
              <div class="items-img-descripcion">
                <img loading="lazy" src="/assets/img/landing/caracteristicas/icon-whatsapp.svg" class="img-fluid small" alt="Recordatorios por WhatsApp">
                <div class="cont-descripcion small-des">
                  <span class="text-info">WhatsApp</span>
                  <br>
                  <p class="descripcion text-white">Confirma citas en la App favorita de tus clientes de forma automática.</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 my-lg-4">
              <div class="items-img-descripcion">
                <img loading="lazy" src="/assets/img/landing/caracteristicas/icon-sms.svg" class="img-fluid small" alt="Notificaciones por SMS">
                <div class="cont-descripcion small-des">
                  <span class="text-info">SMS</span>
                  <br>
                  <p class="descripcion text-white">Cobertura total. Notifica incluso si tu cliente no tiene conexión a internet.</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 my-lg-4">
              <div class="items-img-descripcion">
                <img loading="lazy" src="/assets/img/landing/caracteristicas/icon-correo.svg" class="img-fluid small" alt="Campañas de Email Marketing">
                <div class="cont-descripcion small-des">
                  <span class="text-info">Correo Electrónico</span>
                  <br>
                  <p class="descripcion text-white">Detalles del servicio y promociones directas a la bandeja de entrada.</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 my-lg-4">
              <div class="items-img-descripcion">
                <img loading="lazy" src="/assets/img/landing/caracteristicas/icon-correo.svg" class="img-fluid small" alt="Notificaciones Push para el staff">
                <div class="cont-descripcion small-des">
                  <span class="text-info">Notificaciones Push</span>
                  <br>
                  <p class="descripcion text-white">Tu equipo sabrá al instante si una cita fue confirmada o cancelada.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 justify-content-center mt-lg-5">
          <img loading="lazy" src="/assets/img/landing/caracteristicas/celularesHerramientas.svg" class="mt-lg-3 img-fluid w-75" alt="Interfaz móvil de Agéndate App en celulares">
        </div>
      </div>
    </section>
  </div>

  <section class="container features">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-6 text-left">
        <span class="text-info">Gestión Inteligente</span>
        <h3 class="titulos">¿Cómo recuperar el<br>control de tu<br>tiempo y agenda?</h3>
        <div class="linea linea-60"></div><br>
        <div class="linea linea-160"></div>
        <p class="text-info text-features-left">
          Mejora la experiencia del cliente<br>
          mientras reduces drásticamente<br>
          las inasistencias sin mover<br>
          un solo dedo.
        </p>
      </div>
      <div class="col-12 col-md-6 col-lg-6 text-right">
        <h2 class="font-weight-semibold text-primary mt-lg-5">
          Libérate de las tareas repetitivas<br>
          y enfócate en crecer tu marca.
        </h2>
        <div class="linea linea-100 text-right"></div>
        <p class="text-primary">Tu tiempo es dinero, no lo pierdas agendando.</p>
        <p class="font-weight-medium text-features-right">
          En <span class="navy"><strong>Agéndate App</strong></span> sabemos que cada minuto<br>
          cuenta. Hemos diseñado un flujo simple<br>
          para que tus clientes gestionen sus<br>
          propios turnos, liberando a tu personal<br>
          para atender lo que realmente importa:<br>
          la calidad de tu servicio.
        </p>
      </div>
      <div class="col-12 text-center">
        <img loading="lazy" src="/assets/img/landing/caracteristicas/ipad-citas.svg" class="img-fluid w-75" alt="Panel de control de citas en Tablet">
      </div>
      <div class="col-12 col-md-6 col-lg-6 text-left">
        <div class="items-img-descripcion">
          <img loading="lazy" src="/assets/img/iconos/icon-h-mensaje.svg" class="img-fluid medium" alt="Proceso de asignación de citas automatizado">
          <div class="cont-descripcion medium-des">
            <small class="text-info">Agéndate App</small><br>
            <h4 class="subtitulos">Reserva en un clic</h4>
            <p class="descripcion">
              Al asignar una cita, el cliente recibe un enlace directo. Desde allí, podrá confirmar o reprogramar en segundos. Sin llamadas molestas, sin malentendidos.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 text-left">
        <div class="items-img-descripcion">
          <img loading="lazy" src="/assets/img/iconos/icon-h-telefono.svg" class="img-fluid medium" alt="Notificación automática para administradores">
          <div class="cont-descripcion medium-des">
            <small class="text-info">Agéndate App</small><br>
            <h4 class="subtitulos">Actualización Real</h4>
            <p class="descripcion">
              El sistema actualiza tu agenda automáticamente. Si un cliente cancela, el espacio queda libre de inmediato para que otro lo tome. ¡Cero espacios muertos!
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div id="team" class="contFondoTextura mt-5 justify-content-center">
    <section class="container">
      <div class="row">
        <div class="col-12 col-lg-6 text-white cont-titlo-team">
          <span class="text-info">Nuestro Equipo</span>
          <h1 class="titulos text-white">
            Apasionados por digitalizar y potenciar el éxito de tu empresa.
          </h1>
        </div>
        <div class="col-12 col-lg-6 mt-lg-5">
          <p class="parrafos mt-lg-5">
            <span class="text-info">
              Mentes creativas dispuestas a revolucionar tu sector.<br>
            </span>
            <span class="text-white">
              Creamos herramientas que eliminan lo rutinario para que tú puedas dedicarte a ser extraordinario en lo que haces. Transformamos la gestión de citas en una ventaja competitiva.
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="my-5 col-12 col-sm-6 col-lg-4">
          <div class="items-img-descripcion teamAgendate">
            <img loading="lazy" src="/assets/img/landing/avatar13.png" class="img-fluid team" alt="Victor Alejandro Caicedo - Cofounder y Backend Developer">
            <div class="cont-descripcion team-des">
              <p class="cargo-team">Cofounder,<br>Backend Developer.</p>
              <h4 class="nombre-team">Victor Alejandro<br>Caicedo R.</h4>
              <ul class="list-inline social-icon">
                <li class="list-inline-item"><a href="https://www.linkedin.com/in/victor-a-caicedo-r-036887a4/" target="_blanck"><i class="fab fa-linkedin-in"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="my-5 col-12 col-sm-6 col-lg-4">
          <div class="items-img-descripcion teamAgendate">
            <img loading="lazy" src="/assets/img/landing/avatar10.png" class="img-fluid team" alt="Juan Manuel Viveros - CEO y Frontend Developer">
            <div class="cont-descripcion team-des">
              <p class="cargo-team">CEO, Cofounder,<br>Frontend Developer.</p>
              <h4 class="nombre-team">Juan Manuel<br>Viveros M.</h4>
              <ul class="list-inline social-icon">
                <li class="list-inline-item"><a href="https://www.linkedin.com/in/juan-manuel-viveros-m-338263a0/" target="_blanck"><i class="fab fa-linkedin-in"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="my-5 col-12 col-sm-6 col-lg-4">
          <div class="items-img-descripcion teamAgendate">
            <img loading="lazy" src="/assets/img/landing/avatar11.png" class="img-fluid team" alt="Alejandra Aguilar - Trade Marketing Manager">
            <div class="cont-descripcion team-des">
              <p class="cargo-team">Trade Marketing<br>Manager.</p>
              <h4 class="nombre-team">Alejandra<br>Aguilar</h4>
              <ul class="list-inline social-icon">
                <li class="list-inline-item"><a href="https://www.linkedin.com/in/maria-alejandra-aguilar-romero-13549b188/" target="_blanck"><i class="fab fa-linkedin-in"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="my-5 col-12 col-sm-6 col-lg-4">
          <div class="items-img-descripcion teamAgendate">
            <img loading="lazy" src="/assets/img/landing/avatar12.png" class="img-fluid team" alt="Cristian Grajales - Product Designer">
            <div class="cont-descripcion team-des">
              <p class="cargo-team">Product<br>Designer.</p>
              <h4 class="nombre-team">Cristian<br>Grajales</h4>
            </div>
          </div>
        </div>
        <div class="my-5 col-12 col-sm-6 col-lg-4">
          <div class="items-img-descripcion teamAgendate">
            <img loading="lazy" src="/assets/img/landing/avatar14.png" class="img-fluid team" alt="Nelson Daza - Trade Marketing Manager">
            <div class="cont-descripcion team-des">
              <p class="cargo-team">Trade Marketing<br>Manager.</p>
              <h4 class="nombre-team">Nelson<br>Daza</h4>
            </div>
          </div>
        </div>
        <div class="my-5 col-12 col-sm-6 col-lg-4">
          <div class="items-img-descripcion teamAgendate">
            <img loading="lazy" src="/assets/img/landing/avatar15.png" class="img-fluid team" alt="Luisa Fernanda Bermúdez - Product Innovation Manager">
            <div class="cont-descripcion team-des">
              <p class="cargo-team">Product Innovation<br>Manager.</p>
              <h4 class="nombre-team">Luisa Fernanda<br>Bermúdez C.</h4>
              <ul class="list-inline social-icon">
                <li class="list-inline-item"><a href="https://www.linkedin.com/in/luisabermudezc/" target="_blanck"><i class="fab fa-linkedin-in"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <section class="container features">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-6 text-left">
        <span class="text-info">Planes a tu Medida</span>
        <h3 class="titulos">Potencia tu negocio<br>con gestión inteligente</h3>
        <div class="linea linea-60"></div><br>
        <div class="linea linea-160"></div>
        <p class="text-info font-size-1_2">
          La solución líder para<br>
          el agendamiento automatizado.<br>
          Optimiza cada turno, fideliza<br>
          clientes y escala tus ventas.
        </p>
      </div>
      <div class="col-12 col-md-6 col-lg-6 text-left">
        <div class="row">
          <div class="col-12">
            <div class="items-img-descripcion mt-3">
              <img loading="lazy" src="/assets/img/iconos/icon-h-usuario.svg" class="img-fluid medium" alt="Gestión ágil de usuarios y clientes">
              <div class="cont-descripcion medium-des">
                <small class="text-info">Agéndate App</small><br>
                <h4 class="subtitulos">Control Total de Clientes</h4>
                <p class="descripcion">
                  Administra a tu equipo y base de datos con rapidez. ¿Ya tienes una lista de clientes? La integramos en minutos para que no pierdas el ritmo.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="items-img-descripcion mt-3">
              <img loading="lazy" src="/assets/img/iconos/icon-h-reloj.svg" class="img-fluid medium" alt="Reportes de estado de citas en tiempo real">
              <div class="cont-descripcion medium-des">
                <small class="text-info">Agéndate App</small><br>
                <h4 class="subtitulos">Reportes en Tiempo Real</h4>
                <p class="descripcion">
                  ¡Cero esperas! Visualiza al instante quién confirmó, quién canceló y quién está pendiente por responder. Toma decisiones basadas en datos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center">
        <img loading="lazy" src="/assets/img/landing/header_gestioncitas.png" class="img-fluid medium" alt="Dashboard de gestión de citas Agéndate App">
      </div>
      <div class="col-12 text-center">
        <img loading="lazy" src="/assets/img/logos/logo-texto-azul-agendateapp.svg" class="img-fluid medium w-25" alt="Logo oficial Agéndate App">
      </div>
    </div>
  </section>

  <div id="pricing" class="contFondoTexturaPlanes mt-5 justify-content-center">
    <section class="container pricing">
      <div class="row padding-titulo-planes">
        <div class="col-12 text-white text-center">
          <span class="text-info">Planes y Precios</span>
          <h1 class="titulos text-white">
            Invierte en el crecimiento de tu negocio<br>
            <small class="subtitulos text-white">
              Prueba todos los beneficios <span class="text-info">GRATIS por 1 mes.</span><br>
              Escoge el plan que impulse tu productividad hoy mismo.
            </small>
          </h1>
        <span class="text-info">Recibe descuentos del 10%, 12.5%, y 15% por pagos adelantados. ¡Aprovecha!</span>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-lg-4 animate__animated animate__zoomIn">
          <ul class="pricing-plan list-unstyled">
            <li class="pricing-title text-center text-info">
              Plan Gratis<br>
            </li>
            <li class="pricing-desc text-center">
              <p class="text-white">
                Desde<br>
                <span class="font-size-39">$0</span><br>
                Mensual
              </p>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">30 Notificaciones</span><br>
                  <small>(WhatsApp e Email)</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">Hasta 10 Clientes/Mes</span><br>
                  <small>Ideal para independientes que inician</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">Soporte Multicanal</span><br>
                  <small>Email y WhatsApp a tu disposición</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">Entrenamiento Virtual</span><br>
                  <small>Te enseñamos a usar la herramienta</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <small class="text-primary">Módulo de Auto-agendamiento</small>
                </div>
              </div>
            </li>
            <li class="text-center">
              <a [routerLink]="['/cuenta/registrarme']" class="btn btn-lg btn-info rounded-pill text-uppercase font-weight-bold my-4 animate__animated animate__pulse animate__infinite">
                <i class="fas fa-address-card"></i> EMPEZAR GRATIS
              </a>
              <br>
              <a href="https://wa.me/573019246082?text=Hola%20Ag%C3%A9ndate%2C%20estoy%20interesado%20en%20adquirir%20el%20plan%20Gratis" target="_black" class="text-primary text--xl cursor-pointer">
                <i class="fab fa-whatsapp"></i> ¿Tienes dudas? Escríbenos.
              </a>
            </li>
          </ul>
        </div>

        <div class="col-lg-4 animate__animated animate__zoomIn">
          <ul class="pricing-plan list-unstyled">
            <li class="pricing-title text-white bg-info">
              Plan Basic<br>
              <div class="text-primary">Perfecto para Emprendedores</div>
            </li>
            <li class="pricing-desc text-center">
              <p class="text-info">
                Desde<br>
                <span class="font-size-39">$37.000 <small>COP</small></span><br>
                Mensual
              </p>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">200 Notificaciones</span><br>
                  <small>(WhatsApp e Email)</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">Hasta 70 Clientes/Mes</span><br>
                  <small>Potencia tu flujo de trabajo diario</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">4 Entrenamientos</span><br>
                  <small>Capacitación avanzada para tu equipo</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <small class="text-primary">Módulo de auto-agendamiento</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <small class="text-primary">Acceso a Funciones Premium</small>
                </div>
              </div>
            </li>
            <li class="text-center">
              <a [routerLink]="['/cuenta/registrarme']" class="btn btn-lg btn-info rounded-pill text-uppercase font-weight-bold my-4 animate__animated animate__pulse animate__infinite">
                <i class="fas fa-address-card"></i> REGISTRAR NEGOCIO
              </a>
              <br>
              <a href="https://wa.me/573019246082?text=Hola%20Ag%C3%A9ndate%2C%20estoy%20interesado%20en%20adquirir%20el%20plan%20Basic" target="_black" class="text-primary text--xl cursor-pointer">
                <i class="fab fa-whatsapp"></i> Habla con un experto.
              </a>
            </li>
          </ul>
        </div>

        <div class="col-lg-4 animate__animated animate__zoomIn">
          <ul class="pricing-plan list-unstyled">
            <li class="pricing-title text-info">
              Plan Premium<br>
              <div>Ideal para Negocios Masivos</div>
            </li>
            <li class="pricing-desc text-center">
              <p class="text-white">
                Desde<br>
                <span class="font-size-39">$90.000</span><br>
                Mensual
              </p>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">1.000 Notificaciones</span><br>
                  <small>(WhatsApp e Email)</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">Hasta 330 Clientes/Mes</span><br>
                  <small>Para franquicias y centros de alta rotación</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <span class="subtitulos">Soporte Prioritario VIP</span><br>
                  <small>Respuesta inmediata a tus requerimientos</small>
                </div>
              </div>
            </li>
            <li>
              <div class="media">
                <img loading="lazy" src="assets/img/landing/circulo-like.png" class="mr-3 circle-check" alt="Check de beneficio incluido">
                <div class="media-body">
                  <small class="text-primary">Actualizaciones frecuentes sin costo</small>
                </div>
              </div>
            </li>
            <li class="text-center">
              <a [routerLink]="['/cuenta/registrarme']" class="btn btn-lg btn-info rounded-pill text-uppercase font-weight-bold my-4 animate__animated animate__pulse animate__infinite">
                <i class="fas fa-address-card"></i> IR A PREMIUM
              </a>
              <br>
              <a href="https://wa.me/573019246082?text=Hola%20Ag%C3%A9ndate%2C%20estoy%20interesado%20en%20adquirir%20el%20plan%20Premium" target="_black" class="text-primary text--xl cursor-pointer">
                <i class="fab fa-whatsapp"></i> Chatea con nosotros.
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 text-center" style="margin-top: 10px;">
          <div class="rounded-pill todoslosplanes">
            Todos los planes son escalables. Si tu negocio crece y necesitas más notificaciones, puedes ajustarlo en cualquier momento.
          </div>
        </div>
      </div>
    </section>
  </div>

  <section class="container features">
        <div class="">
          <div class="row">
            <div class="col-lg-12 text-center">
              <span class="text-info">Calidad Garantizada</span>
              <h1 class="titulos">Beneficios incluidos en<br>todos nuestros planes.</h1>
              <p class="parrafos text-primary font-size-25">Seguridad y respaldo para que tu única preocupación sea atender a tus clientes.</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-6 mt-5">
              <div class="media">
                <img loading="lazy" src="assets/img/landing/planes/icon-mantenimiento.svg" class="mr-3 features-icon" alt="Seguridad de datos en Agéndate App">
                <div class="media-body mt-lg-4">
                  <small class="text-info">Agéndate App</small><br>
                  <h2 class="subtitulos">Soporte y Seguridad<br>de Nivel Bancario</h2>
                  <p class="descripcion">Tus datos y los de tus clientes están protegidos. Solo el personal autorizado por ti puede acceder a la información.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mt-5">
              <div class="media">
                <img loading="lazy" src="assets/img/landing/planes/icon-confidencialidad.svg" class="mr-3 features-icon" alt="Confidencialidad de la información empresarial">
                <div class="media-body mt-lg-4">
                  <small class="text-primary">Agéndate App</small><br>
                  <h2 class="subtitulos text-info">Confidencialidad<br>Total</h2>
                  <p class="descripcion">Contamos con un equipo técnico listo para resolver dudas y asegurar que tu plataforma nunca se detenga.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row ml-lg-5 justify-content-center">
            <div class="col-lg-6 mt-5">
              <div class="media">
                <img loading="lazy" src="assets/img/landing/planes/icon-backups-diarios.svg" class="mr-3 features-icon" alt="Copias de seguridad diarias automáticas">
                <div class="media-body mt-lg-4">
                  <small class="text-info">Agéndate App</small><br>
                  <h2 class="subtitulos">Respaldo Diario<br>de Información</h2>
                  <p class="descripcion">Evitamos pérdidas de ingresos con backups diarios. Tu agenda estará siempre segura, pase lo que pase.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 mt-5">
              <div class="media">
                <img loading="lazy" src="assets/img/landing/planes/icon-actualizaciones.svg" class="mr-3 features-icon" alt="Actualizaciones de software constantes">
                <div class="media-body mt-lg-4">
                  <small class="text-primary">Agéndate App</small><br>
                  <h2 class="subtitulos text-info">Evolución<br>Constante</h2>
                  <p class="descripcion">Trabajamos cada día para entregarte nuevas herramientas de automatización. Las actualizaciones son automáticas y sin costos ocultos.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  </section>

  <div class="contFondoTexturaFooter mt-5 justify-content-center">
  <section id="contact" class="contact">
    <div class="container">
      <div class="row m-b-lg">
        <div class="col-lg-12 text-center">
          <h1 class="titulos text-white">¿Listo para llevar tu negocio al siguiente nivel?</h1>
          <p class="text-white font-size-25">Únete a cientos de barberías y salones que ya profesionalizaron su agenda.</p>
        </div>
      </div>
      <div class="row m-b-lg mb-lg-5 justify-content-center">
        <div class="col-lg-6 text-center">
          <img loading="lazy" src="assets/img/landing/ilustracion_contactanos.svg" class="mr-3" alt="Contacta con el equipo de soporte de Agéndate App">
        </div>
        <div class="col-lg-6 mt-3 my-lg-5">
          <div class="card card-mensaje-contacto border-0 text-center">
            <div class="card-body">
              <p class="card-text font-size-20">
                <span class="text-info">¿Tienes una duda específica?</span><br>
                <span>
                  Estamos aquí para escucharte.<br>
                  Escríbenos y un experto<br>
                  en digitalización te atenderá<br>
                  en tiempo récord.</span><br>
                <a class="btn btn-lg btn-info rounded-pill text-uppercase font-weight-bold mt-3 {{ constants.gtm.css.contact }}"
                href="https://api.whatsapp.com/send?phone=573019246082"
                target="_black" role="button"><i class="fab fa-whatsapp"></i> HABLAR POR WHATSAPP</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="mt-4 my-2 col-12 col-lg-3 text-center">
          <img loading="lazy" src="assets/img/logos/logo-agendate-blanco.svg" class="mr-3 logo-footer w-75" alt="Logo Agéndate App Blanco">
        </div>
        <div class="my-2 col-12 col-lg-4 cont-redes-sociales">
          <h4 class="m-t-sm text-white">
            ¡Síguenos y optimiza<br>tus procesos!
          </h4>
          <app-social-networks-icons></app-social-networks-icons>
        </div>
        <div class="my-2 col-12 col-lg-4">
          <address>
            <span class="text-info" title="Phone">Celular:</span>
            <a class="text-white {{ constants.gtm.css.contact }}" href="tel:+573166232885">(+57) 316-6232885</a><br>
            <span class="text-info" title="Phone">WhatsApp:</span>
            <a class="text-white {{ constants.gtm.css.contact }}" href="https://api.whatsapp.com/send?phone=573019246082" target="_black">(+57) 301-9246082</a><br>
            Colombia, Santiago de Cali<br />
          </address>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 text-center m-t-lg m-b-lg">
          <p class="text-white"><strong>&copy; {{ currentYear }} Agéndate App</strong> Todos los derechos reservados. | <a class="text-white" [routerLink]="['/terminosycondiciones']" target="_blank">Términos y condiciones</a> | <a class="text-white" [routerLink]="['/politica-de-privacidad']" target="_blank">Política de datos</a></p>
        </div>
      </div>
    </div>
  </section>
  </div>
</div>
